import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { CareProviderGroup } from "@/interfaces/careProviderGroup";
import { Profile } from "@/interfaces/profile";
import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileCircle',
  props: {
    profile: {},
    careProviderGroup: {}
  },
  setup(__props: any) {

const props = __props;

const initials = computed<string>(() => {
  let initials = "  ";
  if (props.profile != undefined) {
    if (props.profile.first_name && props.profile.first_name.length > 0) {
      initials = props.profile.first_name[0].toUpperCase();
    }
    if (props.profile.last_name && props.profile.last_name.length > 0) {
      initials += props.profile.last_name[0].toUpperCase();
    }
    return initials;
  }
  if (props.careProviderGroup != undefined) {
    return props.careProviderGroup.short_name;
  }
  return "";
});

const color = computed<string>(
  () => props.profile?.color ?? props.careProviderGroup?.color ?? ""
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "w-profile h-profile rounded-full flex justify-center items-center select-none profile self-center justify-self-center",
    style: _normalizeStyle({ 'background-color': color.value })
  }, [
    _createElementVNode("p", null, _toDisplayString(initials.value), 1)
  ], 4))
}
}

})